// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import settings from "../../appsettings.json";
import devSettings from "../../appsettings.Development.json";
import axios from "axios";

/**
 * Settings of the application
 */
export class AppSettings {
  isLoaded = false;

  BACKEND_URL = "";
  IDENTITY_URL = "";
  CLIENT_ID = "";
  APPINSIGHTS_INSTRUMENTATIONKEY = "";
  LAST_ACCOUNT_ID_STORAGE_KEY = "mobicrm.outlookaddin.lastaccountid";
  HAS_MENU_BEEN_CLICKED = "mobicrm.outlookaddin.hasmenubeenclicked";

  /**
   * Loads appsettings from json files
   * @returns {Promise<AppSettings>}
   */
  async load(): Promise<AppSettings> {
    // Load settings from appsettings.json file
    Object.assign(this, settings);

    // Load settings overrides for dev environment
    if (process.env.NODE_ENV === "development") {
      Object.assign(this, devSettings);
    } else {
      // Load custom overrides dynamically from server
      try {
        const r = await axios.get("/appsettings.json");
        const webSettings = r.data;
        Object.assign(this, webSettings);
      } catch {}
    }

    this.isLoaded = true;
    return this;
  }
}

const appSettings = new AppSettings();
export default appSettings;
